export function StaffRouteContentSkeleton({ label = 'Загрузка экрана…' }: { label?: string }) {
  return (
    <div
      className="staff-route-content-skeleton"
      role="status"
      aria-live="polite"
      data-testid="staff-route-screen-fallback"
    >
      <span className="sr-only">{label}</span>
      <div className="staff-route-content-skeleton-heading" aria-hidden="true" />
      <div className="staff-route-content-skeleton-line" aria-hidden="true" />
      <div className="staff-route-content-skeleton-line staff-route-content-skeleton-line-short" aria-hidden="true" />
      <div className="staff-route-content-skeleton-card" aria-hidden="true" />
    </div>
  );
}
